import { useLocation, Link, Navigate } from "react-router-dom";
import { CheckCircle, Copy, Mail, Building2, AlertTriangle } from "lucide-react";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function OuvidoriaConfirmacao() {
  const location = useLocation();
  const { protocolo } = location.state || {};

  if (!protocolo) {
    return <Navigate to="/ouvidoria" replace />;
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(protocolo);
    toast.success("Protocolo copiado!");
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <div className="flex items-center justify-center gap-2">
            <div className="w-8 h-8 bg-[#1a1a2e] rounded-lg flex items-center justify-center">
              <Building2 className="w-5 h-5 text-white" />
            </div>
            <span className="font-semibold text-[#1a1a2e]">CONTERP</span>
          </div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-lg w-full">
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-fade-in">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
            <h1 className="text-3xl font-bold text-[#1a1a2e] mb-4">
              Solicitação Registrada!
            </h1>
            <p className="text-slate-600">
              Sua solicitação foi recebida e será analisada pela nossa equipe.
            </p>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8 mb-8 animate-fade-in" style={{ animationDelay: "0.1s" }}>
            {/* Protocol */}
            <div className="mb-6">
              <label className="text-xs font-medium text-slate-500 uppercase mb-2 block">
                Número do Protocolo
              </label>
              <div className="flex items-center gap-3">
                <div className="flex-1 bg-slate-50 rounded-lg p-4 font-mono text-xl font-bold text-[#1a1a2e] tracking-wider">
                  {protocolo}
                </div>
                <Button
                  variant="outline"
                  size="icon"
                  onClick={copyToClipboard}
                  data-testid="copy-protocolo"
                >
                  <Copy className="w-4 h-4" />
                </Button>
              </div>
            </div>

            {/* Info */}
            <div className="bg-[#0EA5E9]/10 rounded-lg p-4 flex gap-3">
              <Mail className="w-5 h-5 text-[#0EA5E9] flex-shrink-0 mt-0.5" />
              <div className="text-sm text-[#1a1a2e]">
                <p className="font-semibold mb-1">Próximos Passos</p>
                <p className="text-slate-600">
                  Você receberá uma resposta no email informado dentro do prazo de SLA estabelecido. 
                  Guarde o número do protocolo para referência.
                </p>
              </div>
            </div>

            {/* Important Notice */}
            <div className="bg-[#f5a623]/10 rounded-lg p-4 flex gap-3 mt-4">
              <AlertTriangle className="w-5 h-5 text-[#f5a623] flex-shrink-0 mt-0.5" />
              <div className="text-sm text-[#1a1a2e]">
                <p className="font-semibold mb-1">Importante</p>
                <p className="text-slate-600">
                  A Ouvidoria é um canal <strong>identificado</strong>. O acompanhamento será feito por email.
                  Se você deseja fazer uma denúncia <strong>anônima</strong>, utilize o{" "}
                  <Link to="/denuncia" className="text-[#0EA5E9] hover:underline">Canal de Denúncias</Link>.
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <Link to="/" className="flex-1">
              <Button className="w-full bg-[#1a1a2e] hover:bg-[#1a1a2e]/90" data-testid="btn-inicio">
                Voltar ao Início
              </Button>
            </Link>
            <Link to="/ouvidoria" className="flex-1">
              <Button variant="outline" className="w-full" data-testid="btn-nova">
                Nova Solicitação
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
